<template>
  <div>
    <px-view-header title="Notas de Entrada" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-tipo-nota-entrada-list-header :on-click-refresh="onClickRefresh"
                                      :on-change-filter="onChangeFilter" />
    <px-tipo-nota-entrada-list :notas-entrada="notasEntrada"
                               :loading="loading"
                               :on-change-options="onChangeOptions"
                               :options-list="optionsList"
                               :footer-options="footerOptions"
                               @remove="onRemove"
                               @update="onClickRefresh"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-tipo-nota-entrada/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import TipoNotaEntradaService from './tipo-nota-entrada-service';
import TipoNotaEntradaList from './TipoNotaEntradaList.vue';
import TipoNotaEntradaListHeader from './TipoNotaEntradaListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Notas de Entrada' },
      ],
      notasEntrada: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemTipoNotaEntrada', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemTipoNotaEntrada', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getTipsoNotasEntrada();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getTiposNotasEntrada();
    },
    onClickRefresh() {
      this.getTiposNotasEntrada();
    },
    onRemove(item) {
      this.loading = true;
      TipoNotaEntradaService.remover(item.id)
        .then(() => {
          this.$toast('Nota de entrada removida com sucesso', { color: 'success' });
          this.getTiposNotasEntrada();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getTiposNotasEntrada() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      TipoNotaEntradaService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.notasEntrada = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxTipoNotaEntradaList: TipoNotaEntradaList,
    pxTipoNotaEntradaListHeader: TipoNotaEntradaListHeader,
  },
};

</script>
